import { makeSimplePostRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { StripeResponse } from "./types";

export const chargeInvestorWithStripe = async (
  token: string,
  amount: string,
  asset: string,
): Promise<StripeResponse> =>
  await makeSimplePostRequest<StripeResponse>(
    `${ORDERBOOK_URL}/stripe_charge/`,
    JSON.stringify({
      public_token: token,
      amount: amount,
      asset: asset,
    }),
    [200],
  );
